import React, { useState } from 'react';
import { PART_TYPES, getPartType } from '../data/partTypes';

const VEHICLE_CLASSES = [
  { id: 'car', label: 'Car' },
  { id: 'truck', label: 'Truck' },
  { id: 'bus', label: 'Bus' },
  { id: 'machinery', label: 'Machinery' },
];

const _ptIds = new Set(PART_TYPES.map(pt => pt.id));

export default function PartTypeSelect({ value, onChange, vehicleClass, onVehicleClassChange, allowCustom = false }) {
  const [showCustom, setShowCustom] = useState(false);
  const [customType, setCustomType] = useState('');

  const filteredTypes = PART_TYPES.filter(pt => pt.vehicleClasses.includes(vehicleClass || 'car'));
  const filteredGroups = [...new Set(filteredTypes.map(pt => pt.group))];
  const valueInFiltered = filteredTypes.some(pt => pt.id === value);
  const existingEntry = value ? getPartType(value) : null;

  return (
    <div>
      {/* Vehicle class toggle */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
        {VEHICLE_CLASSES.map(vc => (
          <button key={vc.id} type="button" onClick={() => onVehicleClassChange(vc.id)}
            style={{
              padding: '4px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer',
              border: vehicleClass === vc.id ? '2px solid var(--blue)' : '1px solid var(--border)',
              background: vehicleClass === vc.id ? 'rgba(37,99,235,0.1)' : 'var(--bg2)',
              color: vehicleClass === vc.id ? 'var(--blue)' : 'var(--text2)',
            }}>{vc.label}</button>
        ))}
      </div>

      {/* Non-canonical value marker */}
      {value && !valueInFiltered && (
        <div style={{ fontSize: 10, color: 'var(--yellow)', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
          <span>Current: <strong>{existingEntry ? existingEntry.display : value}</strong></span>
          <span style={{ color: 'var(--text3)' }}>(pick a replacement below)</span>
        </div>
      )}

      {/* Custom chip or grouped select */}
      {allowCustom && value && !_ptIds.has(value) ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, height: 36, padding: '0 12px', background: 'var(--bg3)', borderRadius: 8, border: '1px solid var(--border)' }}>
          <span style={{ fontSize: 10, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 600 }}>Custom</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text1)' }}>{value}</span>
          <button type="button" onClick={() => onChange('')} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 14, padding: '0 2px', lineHeight: 1 }}>&#10005;</button>
        </div>
      ) : showCustom && allowCustom ? (
        <div style={{ display: 'flex', gap: 6 }}>
          <input className="form-input" value={customType} onChange={e => setCustomType(e.target.value)} placeholder="Custom part type" autoFocus />
          <button type="button" className="btn btn-primary btn-sm" onClick={() => { if (customType.trim()) { onChange(customType.trim()); setCustomType(''); setShowCustom(false); } }}>&#10003;</button>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setShowCustom(false); setCustomType(''); }}>&#10005;</button>
        </div>
      ) : (
        <select className="form-select" value={valueInFiltered ? value : ''} onChange={e => {
          if (e.target.value === '__custom__') { setShowCustom(true); setCustomType(''); }
          else onChange(e.target.value);
        }}>
          <option value="">Select type</option>
          {filteredGroups.map(g => (
            <optgroup key={g} label={g}>
              {filteredTypes.filter(pt => pt.group === g).map(pt => (
                <option key={pt.id} value={pt.id}>{pt.display}</option>
              ))}
            </optgroup>
          ))}
          {allowCustom && <option value="__custom__">+ Custom</option>}
        </select>
      )}
    </div>
  );
}
